export default __webpack_public_path__ + "static/02-76e82da845836b55e39c96c77d857eb3.jpg";